import React, { Component } from 'react';
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import { Table, message, Form, DatePicker, Button, Tag, Tabs } from 'antd';
import { offerApiServices } from "../../services/offer/OfferApiService";
import { offerGcpApiService } from "../../services/offer/OfferGcpApiService";
import { LogAutomaticClosingStates } from "./types/LogAutomaticClosingTypes";
import withAuth from "../../hoc/withAuth";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";
import Cookies from "universal-cookie";

export interface LogAutomaticClosingProps {
}

class LogAutomaticClosing extends Component<LogAutomaticClosingProps & any, LogAutomaticClosingStates> {
    private readonly initState!: LogAutomaticClosingStates;
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    constructor(props: LogAutomaticClosingProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            processingFetchTableData: false,
            processingPreRunner: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataTable: [],
            preRunnerData: [],
            pageSize: 50000,
            filterStartDate: moment().format('YYYY-MM-DD'),
            companyCode: companyCode
        }
        this.state = { ...this.initState }
    }

    onDealerChange = async (data: any) => {
        this.setState({
            processingFetchTableData: false,
            dealerCode: data.value,
        });
    }

    fetchData = async () => {
        this.setState({
            processingFetchTableData: true,
            dataTable: [],
        });

        const params = {
            companyCode: this.state.companyCode.toUpperCase(),
            yearMonth: moment(this.state.filterStartDate).format("YYYY-MM"),
            yearMonthDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
        }

        offerApiServices.getLogAutomaticClosing(params).then((dataFetch) => {
            const responseData = [];
            for (const mapData of dataFetch.data) {
                for (const item in mapData?.data) {
                    responseData.push({ date_time: mapData?.create_time, offer_code: mapData?.data[item]?.offer_code, status: mapData?.data[item]?.result, notes: mapData?.data[item]?.notes });
                }
            }
            this.setState({
                dataTable: responseData,
                processingFetchTableData: false,
            });
        }).catch(async (e) => {
            this.setState({
                dataTable: [],
                processingFetchTableData: false,
            });
            message.error('Data Tidak Ditemukan');
        })
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    async componentDidMount() {

    }

    onFieldChange = <T extends keyof Pick<any, "filterStartDate">>(target: T, value: any) => {
        const currentState: any = { ...this.state };
        switch (target) {
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
        }
        currentState.dataTable = [];
        this.setState({
            ...currentState,
        });
    }

    preRunner = async () => {
        try {
            this.setState({ processingPreRunner: true });
            const response = await offerGcpApiService.preRunner(this.state.companyCode);
            
            const responseData = [];
            for (const key in response.data.data) {
                const item = response.data.data[key];
                responseData.push({
                    date_time: moment().format('YYYY-MM-DD HH:mm'),
                    offer_code: item.offer_code,
                    status: item.result,
                    notes: item.notes
                });
            }
            
            this.setState({
                preRunnerData: responseData
            });
            message.success('Simulasi Closing berhasil dijalankan');
        } catch (error) {
            message.error('Gagal menjalankan Simulasi Closing');
        } finally {
            this.setState({ processingPreRunner: false });
        }
    }

    renderLogClosingTab = () => {
        return (
            <>
                <div style={{ padding: 20 }}>
                    <Form layout={`inline`}>
                        <Form.Item className={'padTop-10'} label="">
                            <i className={`small-text-grey`}>Tanggal Closing</i><br />
                            <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterStartDate", event)} format={'YYYY-MM-DD'} />
                        </Form.Item>
                        <Form.Item className={'padTop-20'}>
                            <Button loading={this.state.processingFetchTableData} onClick={this.fetchData} type="primary" icon={<SearchOutlined />}>Cari Data</Button>
                        </Form.Item>
                    </Form>
                </div>

                <Table
                    rowKey={'offer_code'}
                    size={'small'}
                    scroll={{ x: 'calc(500px + 50%)' }}
                    loading={this.state.processingFetchTableData}
                    columns={[
                        {
                            title: 'Waktu',
                            dataIndex: 'date_time',
                            render: ((value: string, row: []) => {
                                return <span className={`font-90`}>{value?.toString()?.replace('T', " ")?.substring(0, 16)}</span>
                            })
                        }, {
                            title: 'Kode Offer',
                            dataIndex: 'offer_code',
                            render: ((value: string, row: []) => {
                                return <span className={`font-90`}>{value?.toString()}</span>
                            })
                        }, {
                            title: 'Status',
                            dataIndex: 'status',
                            render: ((value: string, row: any) => {
                                let status: any = "-";
                                if (value) {
                                    status = <Tag color="processing">true</Tag>;
                                } else {
                                    status = <Tag color="error">false</Tag>;
                                }
                                return status;
                            })
                        }, {
                            title: 'Catatan',
                            dataIndex: 'notes',
                            render: ((value: string, row: []) => {
                                return <span className={`font-90`}>{value?.toString()}</span>
                            })
                        }
                    ]}
                    dataSource={this.state.dataTable}
                    pagination={{ pageSize: this.state.pageSize }}
                    onChange={this.onChangeTable}
                />
            </>
        )
    }

    renderPreRunnerTab = () => {
        return (
            <div style={{ padding: 20 }}>
                <Button type="primary" onClick={this.preRunner} loading={this.state.processingPreRunner}>
                    Simulasi Closing
                </Button>

                <div style={{ marginTop: 20 }}>
                    <Table
                        rowKey={'offer_code'}
                        size={'small'}
                        scroll={{ x: 'calc(500px + 50%)' }}
                        loading={this.state.processingPreRunner}
                        columns={[
                            {
                                title: 'Waktu',
                                dataIndex: 'date_time',
                                render: ((value: string, row: []) => {
                                    return <span className={`font-90`}>{value?.toString()}</span>
                                })
                            }, {
                                title: 'Kode Offer',
                                dataIndex: 'offer_code',
                                render: ((value: string, row: []) => {
                                    return <span className={`font-90`}>{value?.toString()}</span>
                                })
                            }, {
                                title: 'Status',
                                dataIndex: 'status',
                                render: ((value: string, row: any) => {
                                    let status: any = "-";
                                    if (value) {
                                        status = <Tag color="processing">true</Tag>;
                                    } else {
                                        status = <Tag color="error">false</Tag>;
                                    }
                                    return status;
                                })
                            }, {
                                title: 'Catatan',
                                dataIndex: 'notes',
                                render: ((value: string, row: []) => {
                                    return <span className={`font-90`}>{value?.toString()}</span>
                                })
                            }
                        ]}
                        dataSource={this.state.preRunnerData || []}
                        pagination={{ pageSize: this.state.pageSize }}
                        onChange={this.onChangeTable}
                    />
                </div>
            </div>
        )
    }

    render() {
        const items = [
            {
                key: '1',
                label: 'Log Automatic Closing',
                children: this.renderLogClosingTab(),
            },
            {
                key: '2',
                label: 'Simulasi Closing',
                children: this.renderPreRunnerTab(),
            },
        ];

        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Log Automatic Closing`} defaultSelectedKeys={['m-log-automatic-closing']} defaultOpenKeys={['sm-offer']}>
                    <div style={{ float: "right", fontSize: "85%", color: "grey" }}>Organization: {this.state.companyCode}</div>
                    
                    <Tabs defaultActiveKey="1" items={items} />
                    
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(LogAutomaticClosing), 31));
